import React from 'react';
import { useAuth } from 'context/auth';
import { colors } from 'crono-fe-common/theme';
import IconArrowSTopRight from 'crono-fe-common/icons/Icon-Arrow-S-Top-Right';

interface IProps {
  style?: React.CSSProperties;
  showArrow?: boolean;
  arrowSize?: number;
}

const UpgradeLabel = ({ style, showArrow = false, arrowSize }: IProps) => {
  const { showUpgradeBadges } = useAuth();
  return showUpgradeBadges ? (
    <div
      style={{
        background: colors.nurture,
        color: colors.white,
        borderRadius: 4,
        fontSize: 11,
        lineHeight: '12px',
        fontWeight: 500,
        padding: 4,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        ...style,
      }}
    >
      Upgrade
      {showArrow && (
        <IconArrowSTopRight color={colors.white} size={arrowSize} />
      )}
    </div>
  ) : null;
};

export default UpgradeLabel;
